import { VoteSupport } from 'types';

const indexedVotingSupportNames: VoteSupport[] = ['AGAINST', 'FOR', 'ABSTAIN'];

export default indexedVotingSupportNames;
